import React, { Component } from 'react';
import styled from "styled-components"
import { Table, Spin, message } from 'antd'
import Dashboard from '@/components/DeviceStatus/Dashboard.jsx'
import Filter from '@/components/DeviceStatus/Filter.jsx'
import DeviceAPI from '@/API/device'
import dayjs from 'dayjs'
import { withTranslation } from 'react-i18next';

const DataTable = styled(Table)`
  margin-top:20px;
`

const Div = styled.div`
  padding:0 20px 20px;
`


class DeviceStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: null,
      loading: false,
      deviceStatusList: [],
      filter: {
        productNameList: [],
        endDate: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        size: 'small',
        showTotal: (total) => (this.props.t('Total items', { total: total }))
      }
    };
  }
  filterChange = (key, value) => {
    let field = {}
    field[key] = value
    this.setState(prevState => ({
      filter: {
        ...prevState.filter,
        ...field
      }
    }))
  }
  handleTableChange = (pagination) => {
    this.setState({
      pagination: pagination,
    }, () => {
      this.getData()
    });
  }
  search = () => {
    this.setState((prevState) => ({
      pagination: {
        current: 1,
        ...prevState.pagination
      }
    }))
    this.getData()
  }
  exp = async () => {
    const { filter } = this.state
    const filterObject = Object.assign({}, filter)
    if (filter.endDate) {
      filterObject.endDate = dayjs(filter.endDate).format('YYYY-MM-DD')
    } else {
      filterObject.endDate = dayjs().format('YYYY-MM-DD')
    }
    let res = await DeviceAPI.exportStatusStatistics({
      ...filterObject
    })
    //增加提示导出成功
    if (!res.code) {
      message.success(res.info)
    }

  }
  getData = () => {
    const { filter, pagination } = this.state
    const filterObject = Object.assign({}, filter)
    if (filter.endDate) {
      filterObject.endDate = dayjs(filter.endDate).format('YYYY-MM-DD')
    } else {
      filterObject.endDate = dayjs().format('YYYY-MM-DD')
    }
    DeviceAPI.getStatusStatistics({
      ...filterObject,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize
    }).then((res) => {
      this.setState((prevState) => ({
        statistics: res.total[0],
        deviceStatusList: res.list,
        pagination: {
          ...prevState.pagination,
          total: res.totalCount
        }
      }))
    })
  }
  render() {
    const { statistics, loading, deviceStatusList, pagination } = this.state;
    const { t } = this.props;
    const columns = [
      {
        title: t("Model"),
        dataIndex: 'productName'
      },
      {
        title: t('Marketing Name'),
        dataIndex: 'marketingName'
      },
      {
        title: t("Total IMEIs"),
        dataIndex: 'totalUploadCount'
      },
      {
        title: t('Activating'),
        dataIndex: 'activatingCount'
      },
      {
        title: t('Activate'),
        dataIndex: 'activateCount'
      },
      {
        title: t('Normal'),
        dataIndex: 'normalCount'
      },
      {
        title: t('Locking'),
        dataIndex: 'lockingCount'
      },
      {
        title: t('Locked'),
        dataIndex: 'lockedCount'
      },
      {
        title: t('Unlocking'),
        dataIndex: 'unLockingCount'
      },
      // {
      //   title:t('Unlocked'),
      //   dataIndex:'unLockedCount'
      // },
      {
        title: t('Completed'),
        dataIndex: 'completedCount'
      }
    ];
    return (
      <div>
        {
          statistics ? <Dashboard data={statistics}></Dashboard> : null
        }
        <Filter filterChange={this.filterChange} search={this.search} exp={this.exp}></Filter>
        <Div>
          <Spin spinning={loading}>
            <DataTable columns={columns} dataSource={deviceStatusList} rowKey="index" pagination={pagination} onChange={this.handleTableChange}></DataTable>
          </Spin>
        </Div>
      </div>
    )
  }
}

export default withTranslation()(DeviceStatus);